export class Primary {
  constructor() {
    this.name = 'Primary'
    this.content =  {
      hasIcon: true,
      class: 'fas',
      icon: 'fa-star',
      severalOpen: false,
    }
    this.view = this.viewHtml()
  }

  viewHtml() {
    return 'primary'
  }

  classes() {
    return []
  }

  styles() {
    return []
  }

  titleClasses() {
    return []
  }

  titleStyles() {
    return []
  }

  containerClasses() {
    return []
  }

  containerStyles() {
    return []
  }

  activeChevronStyles() {
    return [
      {property:'TextColor', styleProperty: 'color', value: '#cbd5e0'}
    ]
  }

  inactiveChevronStyles() {
    return [
      {property:'TextColor', styleProperty: 'color', value: '#cbd5e0'}
    ]
  }

  activeTitleStyles() {
    return []
  }

  inactiveTitleStyles() {
    return []
  }

  iconContainerClasses() {
    return [
      {property: 'Rounded', value: 'ROUNDED_LG'},
    ]
  }

  iconContainerStyles() {
    return [
      {property:'BackgroundColor', styleProperty: 'background-image', value: 'linear-gradient(0deg, #f56564, #f56564)'},
    ]
  }

  iconStyles() {
    return [
      {property:'TextColor', styleProperty: 'color', value: '#ffffff'},
    ]
  }

  buildData() {
    return {
      name: this.name,
      view: this.view,
    }
  }

  editorProperties() {
    return {
      content: this.content,
      classes: {
        desktop: this.classes(),
        tablet: this.classes(),
        phone: this.classes()
      },
      styles: {
        desktop: this.styles(),
        tablet: this.styles(),
        phone: this.styles()
      },
      titleClasses: {
        desktop: this.titleClasses(),
        tablet: this.titleClasses(),
        phone: this.titleClasses()
      },
      titleStyles: {
        desktop: this.titleStyles(),
        tablet: this.titleStyles(),
        phone: this.titleStyles()
      },
      containerClasses: {
        desktop: this.containerClasses(),
        tablet: this.containerClasses(),
        phone: this.containerClasses()
      },
      containerStyles: {
        desktop: this.containerStyles(),
        tablet: this.containerStyles(),
        phone: this.containerStyles()
      },
      activeChevronStyles: {
        desktop: this.activeChevronStyles(),
        tablet: this.activeChevronStyles(),
        phone: this.activeChevronStyles()
      },
      inactiveChevronStyles: {
        desktop: this.inactiveChevronStyles(),
        tablet: this.inactiveChevronStyles(),
        phone: this.inactiveChevronStyles()
      },
      activeTitleStyles: {
        desktop: this.activeTitleStyles(),
        tablet: this.activeTitleStyles(),
        phone: this.activeTitleStyles()
      },
      inactiveTitleStyles: {
        desktop: this.inactiveTitleStyles(),
        tablet: this.inactiveTitleStyles(),
        phone: this.inactiveTitleStyles()
      },
      iconContainerClasses: {
        desktop: this.iconContainerClasses(),
        tablet: this.iconContainerClasses(),
        phone: this.iconContainerClasses()
      },
      iconStyles: {
        desktop: this.iconStyles(),
        tablet: this.iconStyles(),
        phone: this.iconStyles()
      },
      iconContainerStyles: {
        desktop: this.iconContainerStyles(),
        tablet: this.iconContainerStyles(),
        phone: this.iconContainerStyles()
      },
    }
  }
}
